<template>
	<!-- Floating toggle (right edge). Badge zeigt die Anzahl aktiver Alarme/Warnungen. -->
	<button
		type="button"
		class="btn btn-circle btn-sm fixed right-4 bottom-4 z-40 shadow-lg"
		:class="count > 0 ? 'btn-error' : 'btn-ghost bg-base-200'"
		:title="t('alerts.widget.title')"
		@click="isOpen = !isOpen">
		<Bell class="h-4 w-4" />
		<span
			v-if="count > 0"
			class="badge badge-warning badge-xs absolute -top-1 -right-1">
			{{ count }}
		</span>
	</button>

	<!-- Backdrop — startet unter der Navbar (top-16); z über dem DynamicHeader (z-100),
	     damit das Panel nicht von der Titelleiste verdeckt wird. -->
	<div v-if="isOpen" class="fixed top-16 right-0 bottom-0 left-0 z-[110] bg-black/20" @click="isOpen = false"></div>

	<!-- Slide-out panel rechts; top-16 = Höhe der oberen Navbar (Avatar/Sprache bleiben frei),
	     z-[120] liegt über dem DynamicHeader (z-100), sonst überdeckt die Titelleiste die Sidebar. -->
	<aside
		class="bg-base-200 fixed top-16 right-0 bottom-0 z-[120] flex w-80 max-w-[90vw] flex-col shadow-2xl transition-transform duration-200"
		:class="isOpen ? 'translate-x-0' : 'translate-x-full'">
		<header class="border-base-300 flex items-center justify-between border-b p-3">
			<span class="font-semibold">{{ t('alerts.widget.title') }}</span>
			<button type="button" class="btn btn-ghost btn-circle btn-xs" @click="isOpen = false">
				<X class="h-4 w-4" />
			</button>
		</header>

		<div class="flex-1 overflow-auto p-2">
			<AlertStatusList />
		</div>
	</aside>
</template>

<script setup lang="ts">
	import { computed, ref } from 'vue'
	import { Bell, X } from 'lucide-vue-next'
	import { useI18n } from 'vue-i18n'
	import { useAlerts } from './useAlerts'
	import AlertStatusList from './AlertStatusList.vue'
	import { _translations } from './_translations'

	const { t } = useI18n(_translations)
	const alertsApi = useAlerts()

	const isOpen = ref(false)
	// Rote Glocke + Badge nur für aktuell auslösende (Alarm/Warnung); die Liste
	// selbst (inkl. init) rendert AlertStatusList.
	const count = computed(() => alertsApi.configuredAlerts.value.filter((i) => i.alert || i.warn).length)
</script>
